import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { OfframpService } from '../../services/offramp.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50
  }
};

@Component({
  selector: 'app-add-offramp-payout-recharge',
  templateUrl: './add-offramp-payout-recharge.component.html',
  styleUrls: ['./add-offramp-payout-recharge.component.css']
})
export class AddOfframpPayoutRechargeDialog implements OnInit {
  element: any = {};
  myForm: any;
  gatewayList: any[] = [];
  quoteList: any[] = [];
  isEditMode: boolean = false;
  recordId: string = '';
  currentUserDisplay: string = '';
  statusOptions = ['PENDING', 'PROCESSING', 'COMPLETED', 'FAILED', 'REJECTED'];

  constructor(
    public dialogRef: MatDialogRef<AddOfframpPayoutRechargeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    public fb: FormBuilder,
    public userService: UserService,
    public offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.element = data.record || {};
    this.isEditMode = !!this.element._id;
    this.recordId = this.element._id || '';

    const loggedInUser = this.userService.getUserDetails();
    this.currentUserDisplay = loggedInUser ? `${loggedInUser.name} (${loggedInUser.email})` : '';

    this.myForm = this.fb.group({
      adminid: [
        this.element.adminid ? (this.element.adminid._id || this.element.adminid) : (loggedInUser ? loggedInUser._id : ''),
        [Validators.required]
      ],
      payout_gateway_id: [
        this.element.payout_gateway_id ? (this.element.payout_gateway_id._id || this.element.payout_gateway_id) : '',
        [Validators.required]
      ],
      exchange_quote_id: [
        this.element.exchange_quote_id ? (this.element.exchange_quote_id._id || this.element.exchange_quote_id) : '',
        [Validators.required]
      ],
      status: [this.element.status || 'PENDING', [Validators.required]],
    });
  }

  ngOnInit() {
    this.loadGatewayList();
    this.loadQuoteList();
  }

  loadGatewayList() {
    this.offrampService.getAllPayoutGateways({ _csrf: this.data._csrf }).subscribe(
      (response: any) => {
        this.gatewayList = (response && response.data) || [];
      },
      () => {
        this.notifSer.error('Error', 'Failed to load payout gateway list', defaults.notif);
        this.gatewayList = [];
      }
    );
  }

  loadQuoteList() {
    const filter = { _csrf: this.data._csrf, limit: 10000, page: 1 };
    this.offrampService.getAllOfframpExchangeQuotes(filter).subscribe(
      (response: any) => {
        this.quoteList = (response && response.data) || [];
      },
      () => {
        this.notifSer.error('Error', 'Failed to load exchange quote list', defaults.notif);
        this.quoteList = [];
      }
    );
  }

  saveRecharge() {
    const { notif } = defaults;

    if (this.myForm.invalid) {
      this.notifSer.error('Error', 'Please fill all required fields', notif);
      return;
    }

    this.spinnerService.show();

    const formData: any = {
      ...this.myForm.value,
      _csrf: this.data._csrf
    };

    if (this.isEditMode) {
      formData._id = this.recordId;
      this.offrampService.updateOfframpPayoutRecharge(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Payout recharge updated successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to update payout recharge', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to update payout recharge', notif);
        }
      );
    } else {
      this.offrampService.createOfframpPayoutRecharge(formData).subscribe(
        (response) => {
          this.spinnerService.hide();
          if (response.status || response.success) {
            this.notifSer.success('Success', response.message || 'Payout recharge created successfully', notif);
            this.dialogRef.close({ success: true, data: response });
          } else {
            this.notifSer.error('Error', response.message || 'Failed to create payout recharge', notif);
          }
        },
        (err) => {
          this.spinnerService.hide();
          this.notifSer.error('Error', (err.error && err.error.message) || 'Failed to create payout recharge', notif);
        }
      );
    }
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-payout-recharges/add-offramp-payout-recharge/add-offramp-payout-recharge.component.ts